module.exports = __webpack_public_path__ + "static/img/1.e2ab57b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/zh/1.png
// module id = T33l
// module chunks = 0